import { render, staticRenderFns } from "./StackedGiveawayStartsIn.vue?vue&type=template&id=2d572db8&lang=pug&"
import script from "./StackedGiveawayStartsIn.vue?vue&type=script&lang=js&"
export * from "./StackedGiveawayStartsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports